import Furniture from './Furniture';
// import { NIGHT_TINT } from 'app/constants/AppConstants.js';

const STATE_DOWN = 1;
const STATE_UP = 2;

export default class RolyPolyLog extends Furniture {
  constructor({ game, location, data }) {
    super({ game, location, data });

    this.state = STATE_DOWN;
    this.isDay = true;

    this.objects = []; // objects placed on top of the rock

    this.addButton();

    this.addMagnifierIcon();

    //
    if (data.state && data.state === 'up') {
      this.state = STATE_UP;
      this.log.y = -60;
      this.magnifierIcon.show();
    }
  }

  createAsset() {
    this.back = this.game.make.image(47, -22, 'roly_poly_log', 'grass_back');
    this.back.anchor.set(0.5, 1);
    this.log = this.game.make.image(45, -24, 'roly_poly_log', 'stump');
    this.log.anchor.set(0.5, 1);
    this.front = this.game.make.image(0, 0, 'roly_poly_log', 'grass_front');
    this.front.anchor.set(0.5, 1);
    this.rolypoly = this.game.make.spine(0, -20, 'spine_roly_poly');
    this.rolypoly.anchor.set(0.5, 1);
    this.rolypoly.setAnimationByName(0, 'animation', true);

    this.addChild(this.back);
    this.addChild(this.rolypoly);
    this.addChild(this.log);
    this.addChild(this.front);
  }

  updateBounds() {
    this.bb = this.getBounds();
    this.bb.width = 300;
    this.bb.height = 160;
  }

  // functions for moving furnitures like rock or log
  addObject(obj) {
    if (this.objects.indexOf(obj) === -1) {
      this.objects.push(obj);
    }
  }

  removeObject(obj) {
    const ind = this.objects.indexOf(obj);
    this.objects.splice(ind, 1);
  }

  //
  getTop(bb) {
    const bb1 = new Phaser.Rectangle();
    const bb2 = this.log.getBounds(); // rock bounds
    const top = this.data.top[0];
    bb1.x = bb2.x + top.x;
    bb1.y = bb2.y + top.y;
    bb1.width = top.w;
    bb1.height = top.h;
    if (Phaser.Rectangle.intersects(bb, bb1)) {
      return { y: bb1.y, h: top.h, character: top.character };
    }
    return null;
  }

  getSide(bb) {
    const bb1 = new Phaser.Rectangle();
    const bb2 = this.log.getBounds(); // rock bounds
    const side = this.data.side[0];
    bb1.x = bb2.x + side.x;
    bb1.y = bb2.y + side.y;
    bb1.width = side.w;
    bb1.height = side.h + (this.state === STATE_UP ? 36 : 0);
    if (Phaser.Rectangle.intersects(bb, bb1)) {
      return { y: bb1.y, h: bb1.height };
    }
    return null;
  }

  //
  setLight(power) {
    this.setLight2(power);
  }

  updateTint(tween, value, tweenData) {
    super.updateTint(tween, value, tweenData);

    this.back.tint = this.tintColor;
    this.front.tint = this.tintColor;
    this.log.tint = this.tintColor;
  }

  //
  addButton() {
    this.log.inputEnabled = true;
    this.log.events.onInputDown.add(this.handleInputDown, this);
    this.log.input.pixelPerfectClick = true;
    this.log.input.pixelPerfectOver = true;
    this.log.input.useHandCursor = true;
  }

  //
  handleInputDown() {
    this.location.state.interacted(this);

    //
    if (this.state === STATE_DOWN) {
      this.state = STATE_UP;
      this.prevY = this.log.y;
      this.game.add
        .tween(this.log)
        .to({ y: -60 }, 500, Phaser.Easing.Quadratic.Out, true)
        .onUpdateCallback(this.updateMove, this);
      this.magnifierIcon.show();
    } else {
      this.state = STATE_DOWN;
      this.prevY = this.log.y;
      this.game.add
        .tween(this.log)
        .to({ y: -24 }, 500, Phaser.Easing.Quadratic.Out, true)
        .onUpdateCallback(this.updateMove, this);
      this.magnifierIcon.hide();
    }

    this.game.sounds.playSFX('item_log', { spriteID: 'sfx' });

    //
    this.onChange.dispatch();
  }

  updateMove() {
    const dy = this.log.y - this.prevY;
    this.prevY = this.log.y;

    for (let i = 0; i < this.objects.length; i++) {
      const obj = this.objects[i];
      obj.y += dy;
      obj.dz -= dy;
    }
  }

  onCloseMacroView() {
    this.state = STATE_DOWN;
    this.game.add.tween(this.log).to({ y: -24 }, 500, Phaser.Easing.Quadratic.Out, true);
    this.magnifierIcon.hide();
  }

  //
  serialize() {
    const data = super.serialize();
    data.state = this.state === STATE_UP ? 'up' : 'down';
    return data;
  }
}
